"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceType = void 0;
var ServiceType;
(function (ServiceType) {
    ServiceType["KSC_HOSTED"] = "KscHosted";
})(ServiceType || (exports.ServiceType = ServiceType = {}));
